import _ from "lodash";

import { connect } from "react-redux";
import DatenTabellen from "./DatenTabellen";
import { compressorIsInstalled, compressorNameOrNumber } from "../model/Kompressor";
import { setYValueAction, setYComponentAction, setXRangeAction, chartsSetDataSourceAction, CHARTS_DATA_SOURCE_LIVE_STANDARD} from "../model/Diagramme";

const makeYComponent = (index, make_label) => ({
	index: index,
	makeLabel: make_label
});

let lastYComponents = [];
let lastAvailableYComponents = [];

const makeYComponents = compressors => {
	/*
	 * erst mal schauen was es jetzt gibt
	 */
	let now = [-1];
	compressors.forEach((compressor, i) => {
		if (compressorIsInstalled(compressor)) {
			now.push(i);
		}
	});
	if (_.isEqual(now, lastAvailableYComponents)) {
		return lastYComponents;
	}

	/*
	 * und nur wenn wir echt müssen bauen wir neue Objekte!
	 */
	let choices = [
		makeYComponent(-1, intl => intl.formatMessage({ id: "Master control"}))
	];
	compressors.forEach((compressor, i) => {
		if (compressorIsInstalled(compressor)) {
			choices.push(makeYComponent(i, intl =>
				intl.formatMessage({ id: "Compressor" }) + " " +
				compressorNameOrNumber(compressor)));
		}
	});
	/*
	 * und noch puffern!
	 */
	lastAvailableYComponents = now;
	lastYComponents = choices;

	return lastYComponents;
};

const assertXRange = (charts) => {

	let result = charts.x_range;
	if (!result) {
		result = [0, 1];
	}
	return result;
};

const getValidXRange = (state) => {
	if(state.charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
		return state.data_log.xrange
	}
	else { // CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
		return state.he_data_log_files.xrange
	}
}

export default connect(
	state => ({
		x_range: assertXRange(state.charts),
		x_range_valid: getValidXRange(state),
		y_values: state.charts.y_values,
		y_value: state.charts.y_value,
		y_components: makeYComponents(state.ablauf.compressors),
		y_component_index: state.charts.y_component_index,
		log_values: state.charts.log_values,
		units: state.units,
		dataSourceOfCharts: state.charts.data_source_index
	}), 
	dispatch => ({
		changeYValue: index => {
			dispatch(setYValueAction(index));
		},
		changeYComponent: index => {
			dispatch(setYComponentAction(index));
		},
		setNewRangeX: (newRange) => {
			dispatch(setXRangeAction(newRange));
		},
		setDataSourceOfCharts: (dataSourceIndex) => {
			dispatch(chartsSetDataSourceAction(dataSourceIndex))
		}
	})
)(DatenTabellen);